import { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import { api, photoUrl } from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Badge } from "../components/ui/badge";

export default function Compare() {
  const [entries, setEntries] = useState([]);
  const [leftId, setLeftId] = useState(undefined);
  const [rightId, setRightId] = useState(undefined);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/entries");
        const list = data || [];
        setEntries(list);
        if (list.length >= 2) { setLeftId(list[list.length - 1].id); setRightId(list[0].id); }
        else if (list.length === 1) { setLeftId(list[0].id); }
      } catch (e) { console.error(e); }
    })();
  }, []);

  const left = entries.find(e => e.id === leftId);
  const right = entries.find(e => e.id === rightId);
  const sev = (v) => v <= 3 ? "bg-emerald-200 text-emerald-900" : v <= 6 ? "bg-amber-200 text-amber-900" : "bg-rose-200 text-rose-900";

  return (
    <AppShell>
      <div>
        <p className="text-xs uppercase tracking-[0.18em] text-sage-500">Side-by-side</p>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight text-stone-900 mt-2">Compare days</h1>
      </div>

      {entries.length < 2 ? (
        <div className="mt-10 bg-white rounded-2xl p-10 text-center border border-stone-100">
          <p className="text-stone-500">Log at least two entries to compare.</p>
        </div>
      ) : (
        <div className="mt-8 grid md:grid-cols-2 gap-6">
          <SidePanel label="Earlier" entry={left} entries={entries} value={leftId} onChange={setLeftId} sev={sev} testid="compare-left"/>
          <SidePanel label="Recent" entry={right} entries={entries} value={rightId} onChange={setRightId} sev={sev} testid="compare-right"/>
        </div>
      )}
    </AppShell>
  );
}

function SidePanel({ label, entry, entries, value, onChange, sev, testid }) {
  return (
    <div className="bg-white rounded-2xl p-6 border border-stone-100" data-testid={testid}>
      <p className="text-xs uppercase tracking-[0.18em] text-sage-500">{label}</p>
      <div className="mt-2">
        <Select value={value || undefined} onValueChange={onChange}>
          <SelectTrigger className="bg-stone-50 border-stone-200 rounded-xl" data-testid={`${testid}-select`}><SelectValue placeholder="Choose entry"/></SelectTrigger>
          <SelectContent>
            {entries.map(e => <SelectItem key={e.id} value={e.id}>{e.entry_date} — {(e.body_regions||[]).join(", ") || "—"}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      {entry?.photo_paths?.[0] ? (
        <img src={photoUrl(entry.photo_paths[0])} alt="" className="mt-4 w-full h-72 object-cover rounded-xl" data-testid={`${testid}-image`}/>
      ) : (
        <div className="mt-4 w-full h-72 bg-sand-200 rounded-xl flex items-center justify-center text-stone-400">No photo</div>
      )}
      {entry && (
        <div className="mt-4 flex gap-2 flex-wrap">
          {(entry.enabled_symptoms || ["itching", "pain", "redness"]).map((s) => {
            const labels = { itching: "Itch", pain: "Pain", redness: "Red", dryness: "Dry", weeping: "Weep" };
            const v = entry[s] || 0;
            return <Badge key={s} className={`${sev(v)} border-0 rounded-full font-mono`}>{labels[s]} {v}</Badge>;
          })}
        </div>
      )}
      {entry?.notes && <p className="mt-4 text-sm text-stone-600 leading-relaxed">{entry.notes}</p>}
    </div>
  );
}
